import React from 'react'
import './Milestone.css'

const Milestone = () => {
  return (
    <div className="main2m">
        <div className="top1m">
            <p className="Heam">Milestone</p>
            {/* <p className="webm"><a href='/Home'>Swajit Engineering Pvt.Ltd. </a> Milestone</p> */}
        </div>
        
        <div className="list1m">
            <ol>
            <li>Started Business in 1990 by first Fabrication shop at Waluj MIDC.</li>
            </ol>
        </div>
    </div>
  )
}

export default Milestone